import _jsx from "@babel/runtime/helpers/jsx";
var _ModalHeader;
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalTitle, ModalFooter } from 'reaxl';
import FilterLocationForm from '../FilterLocationForm';
function FilterLocationModal(_ref) {
  let {
    show = false,
    onHide = () => {},
    onSubmit = () => {},
    onOptionChange = () => {},
    filter = {},
    filters = {},
    errors = {},
    values = {},
    searchRadiusValue,
    zipValue,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Modal, Object.assign({
    "data-cmp": "filterLocation",
    show: show,
    onHide: onHide,
    bsSize: "small"
  }, rest), _ModalHeader || (_ModalHeader = /*#__PURE__*/_jsx(ModalHeader, {
    closeButton: true
  }, void 0, /*#__PURE__*/_jsx(ModalTitle, {}, void 0, "Change your location"))), /*#__PURE__*/_jsx(ModalBody, {}, void 0, /*#__PURE__*/_jsx(FilterLocationForm, {
    filter: filter,
    filters: filters,
    values: values,
    errors: errors,
    onOptionChange: onOptionChange,
    searchRadiusValue: searchRadiusValue,
    zipValue: zipValue
  })), /*#__PURE__*/_jsx(ModalFooter, {}, void 0, /*#__PURE__*/_jsx(Button, {
    onClick: onHide
  }, void 0, ' ', "Cancel"), /*#__PURE__*/_jsx(Button, {
    onClick: e => {
      onSubmit(e, onHide);
    },
    bsStyle: "primary",
    type: "submit"
  }, void 0, ' ', "Submit")));
}
export default FilterLocationModal;